var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2974_16093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 42C34.4411 42 42.5 33.9411 42.5 24C42.5 14.0589 34.4411 6 24.5 6C14.5589 6 6.5 14.0589 6.5 24C6.5 33.9411 14.5589 42 24.5 42Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36C25.7426 36 26.75 34.9926 26.75 33.75C26.75 32.5074 25.7426 31.5 24.5 31.5C23.2574 31.5 22.25 32.5074 22.25 33.75C22.25 34.9926 23.2574 36 24.5 36Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.0015V25.5015C25.5384 25.5015 26.5534 25.1936 27.4167 24.6167C28.2801 24.0398 28.953 23.2199 29.3504 22.2606C29.7477 21.3012 29.8517 20.2456 29.6491 19.2272C29.4466 18.2088 28.9465 17.2734 28.2123 16.5392C27.4781 15.8049 26.5426 15.3049 25.5242 15.1023C24.5058 14.8998 23.4502 15.0037 22.4909 15.4011C21.5316 15.7985 20.7117 16.4714 20.1348 17.3347C19.5579 18.1981 19.25 19.2131 19.25 20.2515",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2974_16093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.39537a01b3f09da9b92b06cbc4bf6cb6.svg";
export { ForwardRef as ReactComponent };